import { GET_MAP_STATES, STATES_FOR_SELECT, GET_STATES, MAP_LOADING, GET_MAP_STATE_CONTACTS } from './types'

const initialState = {
  states: [],
  statesForSelect: [],
  state: {},
  loading: false,
  contacts: {
    data: [],
    query: { first: 0, limit: 10, totalRecords: 0 },
  },
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MAP_STATES:
      return {
        ...state,
        state: action.payload,
      }
    case STATES_FOR_SELECT:
      return {
        ...state,
        statesForSelect: action.payload,
      }
    case GET_STATES:
      return {
        ...state,
        states: action.payload,
      }
    case MAP_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case GET_MAP_STATE_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      }
    default:
      return state
  }
}
